import React, { useEffect } from "react";
import { useColors } from "../context/colorContext";
import Layout from "./layout";

const ProductsComponent = props => {
  const { updateColors } = useColors();
  const section = "products";

  const colorComponent = Object.values(props).filter(
    component => component.moduleTitle === "component--colour"
  );

  const styles =
    colorComponent.length > 0
      ? colorComponent[0].json
        ? JSON.parse(colorComponent[0].json)
        : null
      : null;

  useEffect(() => {
    if (styles) {
      updateColors(section, styles);
    }
  }, []);

  return (
    <>
      <Layout section={section} colors={styles} {...props} />
    </>
  );
};

export default ProductsComponent;
